"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-shrink: 0;\n  height: 40px;\n  padding: 0 0 0 8px;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n\n  &.selected {\n    color: ", ";\n    background: ", ";\n  }\n\n  .checkbox {\n    margin: 0 8px 0 0;\n    pointer-events: none;\n  }\n\n  .label {\n    font-size: 14px;\n    font-family: ", ";\n    pointer-events: none;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n  }\n"], ["\n  display: flex;\n  flex-shrink: 0;\n  height: 40px;\n  padding: 0 0 0 8px;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n\n  &.selected {\n    color: ", ";\n    background: ", ";\n  }\n\n  .checkbox {\n    margin: 0 8px 0 0;\n    pointer-events: none;\n  }\n\n  .label {\n    font-size: 14px;\n    font-family: ", ";\n    pointer-events: none;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map